'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _deepFreeze = require('deep-freeze');

var _deepFreeze2 = _interopRequireDefault(_deepFreeze);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var constants = {
  datePickerPeriods: ['day', 'week', 'month', 'quarter', 'halfyear', 'year', 't30', 'rollingQuarter', ''],
  QUARTER_MONTHS: {
    1: 0,
    2: 3,
    3: 6,
    4: 9
  },
  HALFYEAR_MONTHS: {
    0: 9,
    1: 0,
    2: 3,
    3: 6,
    4: 9
  },
  QUARTERS: {
    1: {
      label: 'Q1',
      months: [{
        number: 0,
        label: 'Jan'
      }, {
        number: 1,
        label: 'Feb'
      }, {
        number: 2,
        label: 'Mar'
      }]
    },
    2: {
      label: 'Q2',
      months: [{
        number: 3,
        label: 'Apr'
      }, {
        number: 4,
        label: 'May'
      }, {
        number: 5,
        label: 'Jun'
      }]
    },
    3: {
      label: 'Q3',
      months: [{
        number: 6,
        label: 'Jul'
      }, {
        number: 7,
        label: 'Aug'
      }, {
        number: 8,
        label: 'Sep'
      }]
    },
    4: {
      label: 'Q4',
      months: [{
        number: 9,
        label: 'Oct'
      }, {
        number: 10,
        label: 'Nov'
      }, {
        number: 11,
        label: 'Dec'
      }]
    }
  },
  PERIODS_WITH_LAST_UPDATED_DATE: ['quarter', 'halfyear', 'year', 'rollingQuarter'],
  PERIOD_TYPE_TO_NUMERIC_MONTH_DURATION: {
    quarter: 3,
    rollingQuarter: 3,
    halfyear: 6,
    year: 12
  },
  TOTAL_MONTHS: 12
};
exports.default = (0, _deepFreeze2.default)(constants);